import { NoteDTO } from 'common/utils/util.type';
export interface Division {
  id: string;
  code: string;
  name: string;
  note?: NoteDTO;
}
export enum LineItemUnitEnum {
  SF = 'SF',
  LS = 'LS',
  Units = 'Units',
  Stops = 'Stops',
  Stories = 'Stories',
  Buildings = 'Buildings',
}
export enum LineItemLabelEnum {
  Allowances = 'Allowances',
  Mobilizations = 'Mobilizations',
  ChangeOrder = 'ChangeOrder',
}
export type LineItemUnit = keyof typeof LineItemUnitEnum | null;
export type LineItemLabel = keyof typeof LineItemLabelEnum | null;
export interface LineItem {
  id: string;
  description: string;
  unit: LineItemUnit;
  divisionId: string | null;
}

export interface LineItemWithDivision {
  id: string;
  description: string;
  unit: string;
  division?: Division;
}

export interface LineItemForPrediction {
  id: string;
  description: string;
  division?: string;
  revisedBudget?: number;
}

export interface PredictedLineItemWithDivision {
  id: string;
  description: string;
  division: Division | null;
  revisedBudget?: number;
  preAssignedDivision?: boolean;
}
